// extracted by mini-css-extract-plugin
module.exports = {"el":"OffsetAnchor-el_18accf10"};